// Which process created an OutsourcedIOBLineItemDetail row.
// Mirrors Tp_Communication.Enum.OutsourcedSourceTypeTextEnum and the DB check constraint.
// TimeBased/Manual rows walk the approval flow; OutsourcedFte/ReverseFte rows are the breakdown of an
// IOB that already exists, so they are read-only here.
const OutsourcedSourceTypeEnum = {
  TimeBased: 'TimeBased',
  Manual: 'Manual',
  OutsourcedFte: 'OutsourcedFte',
  ReverseFte: 'ReverseFte',
};

export const OutsourcedSourceTypeLabels = {
  [OutsourcedSourceTypeEnum.TimeBased]: 'Time-Based',
  [OutsourcedSourceTypeEnum.Manual]: 'Manual',
  [OutsourcedSourceTypeEnum.OutsourcedFte]: 'Outsourced FTE',
  [OutsourcedSourceTypeEnum.ReverseFte]: 'Reverse FTE',
};

export default OutsourcedSourceTypeEnum;
